// Angular
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// Components
import {BaseComponent} from './views/theme/base/base.component';
import {ErrorPageComponent} from './views/theme/content/error-page/error-page.component';
// Auth
import {AuthGuard} from './core/auth';


const routes: Routes = [
	 {path: 'auth', loadChildren: () => import('app/views/pages/auth/auth.module').then(m => m.AuthModule)},
	 {path: 'shoplineitau', loadChildren: () => import('app/views/pages/shopline-itau/shopline-itau.module').then(m => m.ShoplineItauModule)},
	{

		path: '',

		loadChildren: () => import('app/views/pages/checkout/checkout.module').then(m => m.CheckoutModule),
	},
	{
		path: 'xxxxxxxx',
		
		component: BaseComponent,
		canActivate: [AuthGuard],
		children: [
		
			{
				path: 'entries',
				loadChildren: () => import('app/views/pages/entries/entries.module').then(m => m.EntriesModule),
			},
			{
				path: 'operational',
				loadChildren: () => import('app/views/pages/operational/operational.module').then(m => m.OperationalModule),
			},
			{
				path: 'reports',
				loadChildren: () => import('app/views/pages/reports/reports.module').then(m => m.ReportsModule),
			},
			{
				path: 'builder',
				loadChildren: () => import('app/views/theme/content/builder/builder.module').then(m => m.BuilderModule)
			},
		
			{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					type: 'error-v6',
					code: 403,
					title: '403... Access forbidden',
					desc: 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator',
				},
			},
			{path: 'error/:type', component: ErrorPageComponent},
			{path: '', redirectTo: 'customer', pathMatch: 'full'},
			{path: '**', redirectTo: 'customer', pathMatch: 'full'},
		],
	
	},
	{path: '**', redirectTo: 'error/403', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {
}
